export default "__VITE_ASSET__e64d7e8a__"